// extracted by mini-css-extract-plugin
module.exports = {"media-breakpoint-sm":"(min-width: 768px)","mediaBreakpointSm":"(min-width: 768px)","list":"_2eoaByyM flex p0","no-border":"_2e4JPY0b","noBorder":"_2e4JPY0b","icon":"_2BFgOMzN"};